// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1addb198","833":"b3c624bc","865":"28eeae6a"}[chunkId] + ".chunk.js";
};